import { IFlyingCart } from "../../IFlyingCart";
import { FlyingCartDesktop } from "./FlyingCartLayouts/FlyingCartDesktop";
import { FlyingCartMobile } from "./FlyingCartLayouts/FlyingCartMobile";
import { useDeviceType } from "@hooks/useDeviceType";
import { IStepRoute } from "@common/StepperRouter";

interface IParams {
    arePricesLoading?: boolean;
    flyingCart: IFlyingCart;
    buttonType?: "button" | "submit";
    nextStep?: IStepRoute;
    onNextClick?(): void;
    isSummaryPage?: boolean;
}

export const FlyingCart = (props: IParams) => {
    const { isMobile } = useDeviceType();

    const { flyingCart, onNextClick, buttonType, nextStep, isSummaryPage, arePricesLoading } = props;

    return isMobile ? (
        <FlyingCartMobile
            arePricesLoading={arePricesLoading}
            buttonType={buttonType}
            flyingCart={flyingCart}
            nextStep={nextStep}
            onNextClick={onNextClick}
        />
    ) : (
        <FlyingCartDesktop
            arePricesLoading={arePricesLoading}
            buttonType={buttonType}
            flyingCart={flyingCart}
            isSummaryPage={isSummaryPage}
            nextStep={nextStep}
            onNextClick={onNextClick}
        />
    );
};
